import { ColorsConfig } from '../colors/colors.config';

export class RiskMappingConfig {
	public static readonly EQUITY_STYLE_OTHER_FACTORS = ['SmallCap', 'Reversal', 'Liquidity', 'Earnings Yield', 'Sentiment', 'Emerging', 'Oil'];
	public static readonly EQUITY_RISK_GROUPS = [
		{
			name: 'Equity Market',
			isParent: false,
			isSummation: false,
			values: ['equity market']
		},
		{
			name: 'Equity Country',
			isParent: true,
			isSummation: false,
			values: ['united states', 'equity country non us']
		},
		{
			name: 'Equity Sector',
			isParent: false,
			isSummation: false,
			values: ['equity sector']
		},
		{
			name: 'Equity Style',
			isParent: true,
			isSummation: false,
			values: ['size', 'volatility', 'value', 'growth', 'momentum', 'dividend yield', 'leverage', 'profitability', 'equity style other']
		},
		{
			name: 'Fixed Income',
			isParent: false,
			isSummation: true,
			values: [
				'spreads investment grade',
				'spreads high yield',
				'spreads municipal',
				'spreads em',
				'spreads securitized',
				'spreads loans - credit',
				'rates usd',
				'rates non-usd',
				'rates inflation'
			]
		},
		{
			name: 'Alternatives',
			isParent: false,
			isSummation: true,
			values: ['other commodity', 'other alternative']
		},
		{
			name: 'FX',
			isParent: false,
			isSummation: false,
			values: ['foreign exchange']
		},
		{
			name: 'Idiosyncratic',
			isParent: false,
			isSummation: false,
			values: ['idiosyncratic']
		},
		{
			name: 'Other',
			isParent: false,
			isSummation: false,
			values: ['other']
		}
	];

	public static readonly PAC_RISK_FACTORS_GROUPS = [
		{
			name: 'Equity',
			isParent: false,
			isSummation: false,
			values: ['Equity']
		},
		{
			name: 'Rates',
			isParent: false,
			isSummation: false,
			values: ['Rates']
		},
		{
			name: 'Spreads',
			isParent: false,
			isSummation: false,
			values: ['Spreads']
		},
		{
			name: 'Inflation',
			isParent: false,
			isSummation: false,
			values: ['Inflation']
		},
		{
			name: 'Foreign Exchange',
			isParent: false,
			isSummation: false,
			values: ['Foreign Exchange']
		},
		{
			name: 'Alternative',
			isParent: false,
			isSummation: false,
			values: ['Alternative']
		},
		{
			name: 'Idiosyncratic',
			isParent: false,
			isSummation: false,
			values: ['idiosyncratic']
		},
		{
			name: 'Other',
			isParent: false,
			isSummation: true,
			values: ['Other', 'Macro', 'Volatility', 'Time']
		}
	];

	public static readonly FI_RISK_GROUPS = [
		{
			name: 'Rates',
			isParent: true,
			isSummation: true,
			values: ['rates usd', 'rates non-usd']
		},
		{
			name: 'Spreads',
			isParent: true,
			isSummation: true,
			values: ['spreads investment grade', 'spreads high yield', 'spreads municipal', 'spreads em', 'spreads securitized', 'spreads loans - credit']
		},
		{
			name: 'Inflation',
			isParent: false,
			isSummation: false,
			values: ['rates inflation']
		},
		{
			name: 'Equity',
			isParent: false,
			isSummation: true,
			values: [
				'equity market',
				'equity sector',
				'dividend yield',
				'size',
				'growth',
				'leverage',
				'momentum',
				'profitability',
				'value',
				'volatility',
				'united states',
				'equity country non us',
				...RiskMappingConfig.EQUITY_STYLE_OTHER_FACTORS
			]
		},
		{
			name: 'Alternatives',
			isParent: false,
			isSummation: true,
			values: ['other commodity', 'other alternative']
		},
		{
			name: 'FX',
			isParent: false,
			isSummation: false,
			values: ['foreign exchange']
		},
		{
			name: 'Idiosyncratic',
			isParent: false,
			isSummation: false,
			values: ['idiosyncratic']
		},
		{
			name: 'Other',
			isParent: false,
			isSummation: false,
			values: ['other']
		}
	];

	public static readonly PC_OBSERVATIONS_REGION_ALLOCATION_GROUPS = [
		{
			name: 'Emerging',
			isParent: true,
			isSummation: true,
			includedAsEmpty: true,
			values: ['emerging'],
			attributes: { includedAsSubHeader: true, colorTheme: ColorsConfig.DEFAULT_CATEGORICAL_COLORS_ORDERING[0] }
		},
		{
			name: 'UK',
			isParent: true,
			isSummation: true,
			includedAsEmpty: true,
			values: ['uk'],
			attributes: { colorTheme: ColorsConfig.DEFAULT_CATEGORICAL_COLORS_ORDERING[1] }
		}
	];

	public static readonly PC_OBSERVATIONS_FI_RISK_GROUPS = [
		{
			name: 'Spread Risk',
			isParent: true,
			isSummation: true,
			includedAsEmpty: true,
			values: ['spreads'],
			attributes: { includedAsSubHeader: true, colorTheme: ColorsConfig.DEFAULT_CATEGORICAL_COLORS_ORDERING[0] }
		},
		{
			name: 'Rate Risk',
			isParent: true,
			isSummation: true,
			includedAsEmpty: true,
			values: ['rates'],
			attributes: { colorTheme: ColorsConfig.DEFAULT_CATEGORICAL_COLORS_ORDERING[1] }
		},
		{
			name: 'Other',
			isParent: true,
			isSummation: true,
			includedAsEmpty: true,
			values: ['other'],
			attributes: { colorTheme: ColorsConfig.DEFAULT_CATEGORICAL_COLORS_ORDERING[2] }
		}
	];

	public static readonly PC_OBSERVATIONS_TOTAL_RISK = [
		{
			name: 'Equity',
			isParent: true,
			isSummation: true,
			includedAsEmpty: true,
			values: ['Equity'],
			attributes: { colorTheme: ColorsConfig.TOTAL_RISK_COLORS['Equity'] }
		},
		{
			name: 'Rates',
			isParent: true,
			isSummation: true,
			includedAsEmpty: true,
			values: ['rates'],
			attributes: { colorTheme: ColorsConfig.TOTAL_RISK_COLORS['Rates'] }
		},
		{
			name: 'Inflation',
			isParent: true,
			isSummation: true,
			includedAsEmpty: true,
			values: ['inflation'],
			attributes: { colorTheme: ColorsConfig.TOTAL_RISK_COLORS['Inflation'] }
		},
		{
			name: 'Spreads',
			isParent: true,
			isSummation: true,
			includedAsEmpty: true,
			values: ['Spreads'],
			attributes: { colorTheme: ColorsConfig.TOTAL_RISK_COLORS['Spreads'] }
		},
		{
			name: 'Alternatives',
			isParent: true,
			isSummation: true,
			includedAsEmpty: true,
			values: ['Alternatives'],
			attributes: { colorTheme: ColorsConfig.TOTAL_RISK_COLORS['Alternative'] }
		},
		{
			name: 'Foreign Exchange',
			isParent: true,
			isSummation: true,
			includedAsEmpty: true,
			values: ['Foreign Exchange'],
			attributes: { colorTheme: ColorsConfig.TOTAL_RISK_COLORS['Foreign Exchange'] }
		},
		{
			name: 'Idiosyncratic',
			isParent: true,
			isSummation: true,
			includedAsEmpty: true,
			values: ['Idiosyncratic'],
			attributes: { colorTheme: ColorsConfig.TOTAL_RISK_COLORS['Idiosyncratic'] }
		},
		{
			name: 'Other',
			isParent: true,
			isSummation: true,
			includedAsEmpty: true,
			values: ['Other'],
			attributes: { colorTheme: ColorsConfig.TOTAL_RISK_COLORS['Other'] }
		}
	];

	// TODO: move all the colors to variable
	public static readonly FI_ATE_SPECIFIC_RISK_GROUPS = [
		{
			name: 'Spread Risk',
			isParent: true,
			isSummation: true,
			includedAsEmpty: true,
			values: ['spreads investment grade', 'spreads high yield', 'spreads municipal', 'spreads em', 'spreads securitized', 'spreads loans - credit'],
			attributes: { includedAsSubHeader: true, colorTheme: ColorsConfig.DEFAULT_CATEGORICAL_COLORS_ORDERING[0] }
		},
		{
			name: 'Rate Risk',
			isParent: true,
			isSummation: true,
			includedAsEmpty: true,
			values: ['rates usd', 'rates non-usd'],
			attributes: { colorTheme: ColorsConfig.DEFAULT_CATEGORICAL_COLORS_ORDERING[1] }
		},
		{
			name: 'Other',
			isParent: true,
			isSummation: true,
			includedAsEmpty: true,
			values: [
				'equity market',
				'equity sector',
				'idiosyncratic', // this one is total Idio
				'dividend yield',
				'size',
				'growth',
				'leverage',
				'momentum',
				'profitability',
				'value',
				'volatility',
				'united states',
				'equity country non us',
				'rates inflation',
				'other alternative',
				'other commodity',
				'foreign exchange',
				'other',
				...RiskMappingConfig.EQUITY_STYLE_OTHER_FACTORS
			],
			attributes: { colorTheme: ColorsConfig.DEFAULT_CATEGORICAL_COLORS_ORDERING[2] }
		}
	];

	public static readonly TOTAL_RISK_EQUITY_GROUPS = [
		{
			name: 'Equity',
			isParent: false,
			isSummation: true,
			isGroupHeader: true,
			values: [
				'equity market',
				'united states',
				'equity country non us',
				'equity sector',
				'dividend yield',
				'size',
				'growth',
				'leverage',
				'momentum',
				'profitability',
				'value',
				'volatility',
				...RiskMappingConfig.EQUITY_STYLE_OTHER_FACTORS
			]
		},
		{
			name: 'Equity Market',
			isParent: false,
			isSummation: false,
			isGroupMember: true,
			values: ['equity market']
		},
		{
			name: 'Equity Country',
			isParent: true,
			isSummation: false,
			isGroupMember: true,
			values: ['united states', 'equity country non us']
		},
		{
			name: 'Equity Sector',
			isParent: false,
			isSummation: false,
			isGroupMember: true,
			values: ['equity sector']
		},
		{
			name: 'Equity Style',
			isParent: true,
			isSummation: false,
			isGroupMember: true,
			values: ['size', 'volatility', 'value', 'growth', 'momentum', 'dividend yield', 'leverage', 'profitability', 'equity style other']
		}
	];

	public static readonly TOTAL_RISK_FI_GROUPS = [
		{
			name: 'Fixed Income',
			isParent: false,
			isSummation: true,
			isGroupHeader: true,
			values: [
				'rates usd',
				'rates non-usd',
				'rates inflation',
				'spreads investment grade',
				'spreads high yield',
				'spreads municipal',
				'spreads em',
				'spreads securitized',
				'spreads loans - credit'
			]
		},
		{
			name: 'Rates',
			isParent: true,
			isSummation: false,
			isGroupMember: true,
			values: ['rates usd', 'rates non-usd', 'rates inflation']
		},
		{
			name: 'Spreads',
			isParent: true,
			isSummation: false,
			isGroupMember: true,
			values: ['spreads investment grade', 'spreads high yield', 'spreads municipal', 'spreads em', 'spreads securitized', 'spreads loans - credit']
		}
	];

	public static readonly TOTAL_RISK_ALTERNATIVES_GROUP = [
		{
			name: 'Alternatives',
			isParent: false,
			isSummation: true,
			values: ['other commodity', 'other alternative']
		}
	];

	public static readonly TOTAL_RISK_ALTERNATIVES_SEGMENTED_GROUP = [
		{
			name: 'Alternatives',
			isParent: false,
			isSummation: true,
			isGroupHeader: true,
			values: ['other commodity', 'other alternative']
		},
		{
			name: 'Commodity',
			isParent: false,
			isSummation: false,
			isGroupMember: true,
			values: ['other commodity']
		},
		{
			name: 'Alternative',
			isParent: false,
			isSummation: false,
			isGroupMember: true,
			values: ['other alternative']
		}
	];

	public static readonly TOTAL_RISK_MISC_GROUPS = [
		{
			name: 'FX',
			isParent: false,
			isSummation: false,
			values: ['foreign exchange']
		},
		{
			name: 'Idiosyncratic',
			isParent: false,
			isSummation: false,
			values: ['idiosyncratic']
		},
		{
			name: 'Other',
			isParent: false,
			isSummation: false,
			values: ['other']
		}
	];

	public static readonly TOTAL_RISK_GROUPS = [
		...RiskMappingConfig.TOTAL_RISK_EQUITY_GROUPS,
		...RiskMappingConfig.TOTAL_RISK_FI_GROUPS,
		...RiskMappingConfig.TOTAL_RISK_ALTERNATIVES_GROUP,
		...RiskMappingConfig.TOTAL_RISK_MISC_GROUPS
	];

	public static readonly TOTAL_ALTERNATIVE_RISK_GROUPS = [
		...RiskMappingConfig.TOTAL_RISK_EQUITY_GROUPS,
		...RiskMappingConfig.TOTAL_RISK_FI_GROUPS,
		...RiskMappingConfig.TOTAL_RISK_ALTERNATIVES_SEGMENTED_GROUP,
		...RiskMappingConfig.TOTAL_RISK_MISC_GROUPS
	];


	public static readonly TOTAL_RISK_EQUITY_COLLAPSED_GROUPS = [
		{
			name: 'Equity',
			isParent: false,
			isSummation: true,
			isGroupHeader: true,
			values: [
				'equity market',
				'united states',
				'equity country non us',
				'equity sector',
				'dividend yield',
				'size',
				'growth',
				'leverage',
				'momentum',
				'profitability',
				'value',
				'volatility',
				...RiskMappingConfig.EQUITY_STYLE_OTHER_FACTORS
			]
		},
		{
			name: 'Equity Market',
			isParent: false,
			isSummation: false,
			isGroupMember: true,
			values: ['equity market']
		},
		{
			name: 'Equity Country',
			isParent: false,
			isSummation: true,
			isGroupMember: true,
			values: ['united states', 'equity country non us']
		},
		{
			name: 'Equity Sector',
			isParent: false,
			isSummation: false,
			isGroupMember: true,
			values: ['equity sector']
		},
		{
			name: 'Equity Style',
			isParent: false,
			isSummation: true,
			isGroupMember: true,
			values: ['size', 'volatility', 'value', 'growth', 'momentum', 'dividend yield', 'leverage', 'profitability', ...RiskMappingConfig.EQUITY_STYLE_OTHER_FACTORS]
		}
	];

	public static readonly TOTAL_RISK_FI_COLLAPSED_GROUPS = [
		{
			name: 'Fixed Income',
			isParent: false,
			isSummation: true,
			isGroupHeader: true,
			values: [
				'rates usd',
				'rates non-usd',
				'rates inflation',
				'spreads investment grade',
				'spreads high yield',
				'spreads municipal',
				'spreads em',
				'spreads securitized',
				'spreads loans - credit'
			]
		},
		{
			name: 'Rates',
			isParent: false,
			isSummation: true,
			isGroupMember: true,
			values: ['rates usd', 'rates non-usd', 'rates inflation']
		},
		{
			name: 'Spreads',
			isParent: false,
			isSummation: true,
			isGroupMember: true,
			values: ['spreads investment grade', 'spreads high yield', 'spreads municipal', 'spreads em', 'spreads securitized', 'spreads loans - credit']
		}
	];

	public static readonly TOTAL_RISK_ALTERNATIVES_COLLAPSED_GROUPS = [
		{
			name: 'Alternatives',
			isParent: false,
			isSummation: true,
			values: ['other commodity', 'other alternative']
		}
	];

	public static readonly TOTAL_RISK_SEGMENTED_ALTERNATIVES_COLLAPSED_GROUPS = [
		{
			name: 'Alternatives',
			isParent: false,
			isSummation: true,
			isGroupHeader: true,
			values: ['other commodity', 'other alternative']
		},
		{
			name: 'Commodity',
			isParent: false,
			isSummation: false,
			isGroupMember: true,
			values: ['other commodity']
		},
		{
			name: 'Alternative',
			isParent: false,
			isSummation: false,
			isGroupMember: true,
			values: ['other alternative']
		}
	];

	public static readonly TOTAL_RISK_MISC_COLLAPSED_GROUPS = [
		{
			name: 'FX',
			isParent: false,
			isSummation: false,
			values: ['foreign exchange']
		},
		{
			name: 'Idiosyncratic',
			isParent: false,
			isSummation: false,
			values: ['idiosyncratic']
		},
		{
			name: 'Other',
			isParent: false,
			isSummation: false,
			values: ['other']
		}
	];

	public static readonly TOTAL_RISK_GROUPS_COLLAPSED = [
		...RiskMappingConfig.TOTAL_RISK_EQUITY_COLLAPSED_GROUPS,
		...RiskMappingConfig.TOTAL_RISK_FI_COLLAPSED_GROUPS,
		...RiskMappingConfig.TOTAL_RISK_ALTERNATIVES_COLLAPSED_GROUPS,
		...RiskMappingConfig.TOTAL_RISK_MISC_COLLAPSED_GROUPS
	];

	public static readonly TOTAL_RISK_ALTERNATIVE_GROUPS_COLLAPSED = [
		...RiskMappingConfig.TOTAL_RISK_EQUITY_COLLAPSED_GROUPS,
		...RiskMappingConfig.TOTAL_RISK_FI_COLLAPSED_GROUPS,
		...RiskMappingConfig.TOTAL_RISK_SEGMENTED_ALTERNATIVES_COLLAPSED_GROUPS,
		...RiskMappingConfig.TOTAL_RISK_MISC_COLLAPSED_GROUPS
	];

	// PAC equity style factors bucketing
	public static readonly EQUITY_STYLE_FACTORS_GROUPS = [
		{
			name: 'Size',
			isParent: false,
			isSummation: false,
			values: ['Size']
		},
		{
			name: 'Volatility',
			isParent: false,
			isSummation: false,
			values: ['Volatility']
		},
		{
			name: 'Momentum',
			isParent: false,
			isSummation: false,
			values: ['Momentum']
		},
		{
			name: 'Value',
			isParent: false,
			isSummation: false,
			values: ['Value']
		},
		{
			name: 'Growth',
			isParent: false,
			isSummation: false,
			values: ['Growth']
		},
		{
			name: 'Dividend Yield',
			isParent: false,
			isSummation: false,
			values: ['Dividend Yield']
		},
		{
			name: 'Earnings Yield',
			isParent: false,
			isSummation: false,
			values: ['Earnings Yield']
		},
		{
			name: 'Leverage',
			isParent: false,
			isSummation: false,
			values: ['Leverage']
		},
		{
			name: 'Profitability',
			isParent: false,
			isSummation: false,
			values: ['Profitability']
		},
		{
			name: 'Reversal',
			isParent: false,
			isSummation: false,
			values: ['Reversal']
		}
	];

	public static readonly AC_EQUITY_STYLE_FACTORS_GROUPS = [
		{
			name: 'Value',
			isParent: false,
			isSummation: false,
			values: ['Value']
		},
		{
			name: 'Earnings Yield',
			isParent: false,
			isSummation: false,
			values: ['Earnings Yield']
		},
		{
			name: 'Dividend Yield',
			isParent: false,
			isSummation: false,
			values: ['Dividend Yield']
		},
		{
			name: 'Profitability',
			isParent: false,
			isSummation: false,
			values: ['Profitability']
		},
		{
			name: 'Leverage',
			isParent: false,
			isSummation: false,
			values: ['Leverage']
		},
		{
			name: 'Momentum',
			isParent: false,
			isSummation: false,
			values: ['Momentum']
		},
		{
			name: 'Reversal',
			isParent: false,
			isSummation: false,
			values: ['Reversal']
		},
		{
			name: 'Volatility',
			isParent: false,
			isSummation: false,
			values: ['Volatility']
		},
		{
			name: 'Size',
			isParent: false,
			isSummation: false,
			values: ['Size']
		},
		{
			name: 'Growth',
			isParent: false,
			isSummation: false,
			values: ['Growth']
		}
	];

	// PAC equity style factors bucketing
	public static readonly PAC_ALTERNATIVE_RISK_GROUPS = [
		{
			name: 'Hedge Funds',
			isParent: false,
			isSummation: true,
			values: ['Hedge Funds', 'Hedge Funds-v2']
		},
		{
			name: 'Private Equity',
			isParent: false,
			isSummation: false,
			values: ['Private Equity']
		},
		{
			name: 'Real Estate',
			isParent: false,
			isSummation: true,
			values: ['Real Estate', 'Real Estate-v2']
		},
		{
			name: 'Infrastructure Equity',
			isParent: false,
			isSummation: false,
			values: ['Infrastructure Equity']
		},
		{
			name: 'Commodity',
			isParent: false,
			isSummation: false,
			values: ['Commodity']
		},
		{
			name: 'Alternative - Other',
			isParent: false,
			isSummation: true,
			values: ['Index Time Series', 'Real Assets']
		},
		{
			name: 'Alternative Idiosyncratic',
			isParent: false,
			isSummation: false,
			values: ['Idiosyncratic']
		},
		{
			name: 'Other',
			isParent: false,
			isSummation: true,
			values: ['_RESIDUAL_PLUG', 'Other']
		}
	];

	// PAC equity style factors bucketing
	public static readonly EQUITY_RISK_DECOMPOSITION = [
		{
			name: 'Equity Market',
			isParent: false,
			isSummation: false,
			values: ['Equity Market']
		},
		{
			name: 'Equity Style',
			isParent: false,
			isSummation: true,
			values: [
				'Dividend Yield',
				'Earnings Yield',
				'Emerging',
				'Growth',
				'Leverage',
				'Liquidity',
				'Momentum',
				'Oil',
				'Reversal',
				'Sentiment',
				'Size',
				'SmallCap',
				'Value',
				'Volatility'
			]
		},
		{
			name: 'Equity Country',
			isParent: false,
			isSummation: true,
			values: ['United States', 'Equity Country Non US']
		},
		{
			name: 'Equity Specific',
			isParent: false,
			isSummation: false,
			values: ['Idiosyncratic']
		},
		{
			name: 'Equity Sector',
			isParent: false,
			isSummation: false,
			values: ['Equity Sector']
		},
		{
			name: 'Other',
			isParent: false,
			isSummation: true,
			values: [
				'Foreign Exchange',
				'Other',
				'Other Alternative',
				'Other Commodity',
				'Rates Inflation',
				'Rates Non-USD',
				'Rates USD',
				'Spreads EM',
				'Spreads High Yield',
				'Spreads Investment Grade',
				'Spreads Loans - Credit',
				'Spreads Municipal',
				'Spreads Securitized'
			]
		}
	];

	public static getTotalRiskGroupWithOption(groupToFocus?: string): any[] {
		const TOTAL_RISK_GROUPS_BUCKET = [
			{
				name: 'Equity',
				isParent: true,
				isSummation: true,
				includedAsEmpty: true,
				values: [
					'equity market',
					'united states',
					'equity country non us',
					'equity sector',
					'dividend yield',
					'size',
					'growth',
					'leverage',
					'momentum',
					'profitability',
					'value',
					'volatility',
					...RiskMappingConfig.EQUITY_STYLE_OTHER_FACTORS
				],
				attributes: { colorTheme: ColorsConfig.TOTAL_RISK_COLORS['Equity Market'] }
			},
			{
				name: 'Fixed Income',
				isParent: true,
				isSummation: true,
				includedAsEmpty: true,
				values: [
					'rates usd',
					'rates non-usd',
					'rates inflation',
					'spreads investment grade',
					'spreads high yield',
					'spreads municipal',
					'spreads em',
					'spreads securitized',
					'spreads loans - credit'
				],
				attributes: { colorTheme: ColorsConfig.TOTAL_RISK_COLORS['Rates USD'] }
			},
			{
				name: 'Alternatives',
				isParent: true,
				isSummation: true,
				includedAsEmpty: true,
				values: ['other commodity', 'other alternative'],
				attributes: { colorTheme: ColorsConfig.TOTAL_RISK_COLORS['Other Alternative'] }
			},
			{
				name: 'Foreign Exchange',
				isParent: true,
				isSummation: true,
				includedAsEmpty: true,
				values: ['foreign exchange'],
				attributes: { colorTheme: ColorsConfig.TOTAL_RISK_COLORS['Foreign Exchange'] }
			},
			{
				name: 'Idiosyncratic',
				isParent: true,
				isSummation: true,
				includedAsEmpty: true,
				values: ['idiosyncratic'],
				attributes: { colorTheme: ColorsConfig.TOTAL_RISK_COLORS['Idiosyncratic'] }
			},
			{
				name: 'Other',
				isParent: true,
				isSummation: true,
				includedAsEmpty: true,
				values: ['other'],
				attributes: { colorTheme: ColorsConfig.TOTAL_RISK_COLORS['Other'] }
			},
			{
				name: 'Total',
				isParent: true,
				isSummation: true,
				includedAsEmpty: false,
				values: ['total risk'],
				attributes: { hideLabel: true, ignoreInChart: true }
			}
		];
		if (groupToFocus) {
			const focusGroup = TOTAL_RISK_GROUPS_BUCKET.find(group => group.name === groupToFocus);
			if (focusGroup) {
				Object.assign(focusGroup.attributes, { includedAsSubHeader: true });
			}
		}
		return TOTAL_RISK_GROUPS_BUCKET;
	}
}
